<div *ngIf="langs?.length > 1" class="flex flew-row">
  <button
    class="flex flex-row items-center px-3"
    [class]="{
      'bg-vtmn-play-content-brand': lang === currentLang,
      'text-white': lang === currentLang,
    }"
    *ngFor="let lang of langs"
    (click)="setLang(lang)"
  >
    {{ formatLang(lang) }}
  </button>
</div>
